export default function remSet() {
  var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  if (htmlWidth > 1080) {
    htmlWidth = 1080
  }
  var fontsize = htmlWidth / 20;
  document.getElementsByTagName("html")[0].style.fontSize = fontsize + "px";
}